import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { filter, first } from 'rxjs/operators';
import { CustomerSearchBarComponent } from '../../shared/components/customer-searchbar/customer-search-bar.component';
import { ValidatedResponse } from '../../shared/models/validated-response.model';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { IncidentModalComponent } from '../incident-modal.component';
import { IncidentAbandonedVehicle } from '../models/incident-abandoned-vehicle.model';
import { IncidentCustomer } from '../models/incident-customer.model';
import { IncidentLandCategoryType } from '../models/incident-land-category-type.model';
import { AbvFeeService } from '../services/abv-fee.service';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentService } from '../services/incident.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './abandon-vehicle-fee-modal.html'
})
export class AbandonVehicleFeeModalComponent extends IncidentModalComponent<IncidentAbandonedVehicle> {
    public landCategories: IncidentLandCategoryType[];
    @ViewChild('customerSearchBar') customerSearchBarComponent: CustomerSearchBarComponent;

    constructor(
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        private service: AbvFeeService,
        typeService: IncidentTypeService,
        public dialogRef: MatDialogRef<IncidentModalComponent<IncidentAbandonedVehicle>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<IncidentAbandonedVehicle>,
        modalService: MvdModalService,
        incidentService: IncidentService,
        prohibitionService: ProhibitionService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.service = service;
        this.incidentService = incidentService;
        this.isAbv = true;
    }

    protected onInit = (form: any): void => {
    };

    protected onLoadLookups(callback: (error?) => void): void {
        this.incidentService.getLandCategoryTypes().subscribe(r => this.onGetLandCategoryTypesCompleted(r.result, callback), callback);
    }

    private onGetLandCategoryTypesCompleted = (result: IncidentLandCategoryType[], callback: (error?) => void): void => {
        this.landCategories = result;
        callback();
    };

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted = (incident: IncidentAbandonedVehicle, callback: (error?) => void): void => {
        this.data.incident = incident;
        this.showUserInput = true;

        this.incidentForm.get('landCategoryTypeId').setValue(incident.landCategoryTypeId);
        this.incidentForm.get('vin').setValue(incident.vin);

        callback();
    };

    public addCustomer = async (event: any): Promise<void> => {
        if (this.data.incident.customers.some(i => i.id == event.customerNumber)) {
            return;
        }

        let result: ValidatedResponse<IncidentCustomer> = await this.incidentService.getCustomer(event.customerNumber).pipe(first()).toPromise();
        if (result && result.result) {
            let customer: IncidentCustomer = result.result;
            this.data.incident.customers.push(customer);
            this.customerSearchBarComponent.onRemove();
        }
    };

    public confirmRemoveCustomer = (customer: IncidentCustomer): void => {
        this.modalService.confirm()
            .title('Warning')
            .body('If you are sure you want to delete this customer from the abandoned vehicle fee incident record; press Delete again to complete the action.')
            .okBtn('Delete').cancelBtn('Cancel')
            .open().afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.removeCustomer(customer));
    };

    public removeCustomer = (customer: IncidentCustomer): void => {
        let index: number = this.data.incident.customers.findIndex(v => v.id == customer.id);
        this.data.incident.customers.splice(index, 1);
    };

    protected onSaveIncident = (callback: (error?: any) => void): void => {
        this.service.saveIncident(this.data.incident).subscribe(r => {}, callback, callback);
    };

    protected onDeleteIncident = (callback: () => void): void => {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    };

    public onLandChange = (id: number): void => {
        this.data.incident.landCategoryTypeId = id;
    };

    public onVinChange = (vin: string): void => {
        this.data.incident.vin = vin;
    };
}
